module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KG-7673c3d3d0dc3564d28473714822a3b0.png";